import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotLineFormActions のスタイル
 */
export const hotLineFormActionsStyle = tv({
    slots: {
        base: [
            'flex flex-col lg:flex-row-reverse items-center justify-center gap-16',
            'px-16 py-24 lg:py-32',
            'border-solid border-x-0 border-b-0 border-t border-gray-100',
        ],
        button: ['max-w-full'],
    },
});
